/*-- npm packages --*/
import React from 'react';
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';

/*-- component atoms --*/
import CustomLink from '../../atoms/CustomLink/CustomLink.atom';

/*-- interfaces --*/
import { NavItem } from '../../../interfaces/Navigation.interface';
import Blok from '../../../interfaces/Storyblok/Blok.interface';

/*-- assets --*/
import ChevronDown from '../../../assets/svgs/ChevronDown.svg';

interface AccordionStateProps {
  expanded?: boolean;
  disabled?: boolean;
}
interface AccorionItemLinkProps extends Blok {
  link: NavItem;
  state: AccordionStateProps;
  textColor?: 'primary' | 'secondary';
}

interface AccorionItemProps {
  link: NavItem;
  textColor?: 'primary' | 'secondary';
}

const Link: React.FC<AccorionItemLinkProps> = ({ link, state }) => {
  return (
    <div
      className={`w-full flex items-center justify-between text-Primary-900 text-sm font-bold p-4 ${
        state.expanded ? 'bg-sherpa-blue-50 bg-SP7' : 'bg-White'
      }`}
    >
      {link.display_name && (
        <span className="pr-2 text-sherpa-blue-900 text-Primary-700 group-hover:text-Primary-900">
          {link.display_name}
        </span>
      )}
      {!!link.dropdown_list?.length && <ChevronDown className="text-Secondary-300" rotate={state.expanded} />}
    </div>
  );
};
const AccorionItemComponent: React.FC<AccorionItemProps> = ({ link, textColor }) => {
  const handleDataLayerEvent = (label: string, url: string, type: string, parentLabel?: string): void => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'click',
      type,
      button: { text: label, url },
      ...(parentLabel && { menu: { depth: 2, levelOne: parentLabel } }),
      _clear: true,
    });
  };

  return link.dropdown_list?.length ? (
    <AccordionItem key={link._uid} uuid={link._uid} className="group">
      <AccordionItemHeading>
        <AccordionItemButton
          className="focus:ring-0 focus:outline-none"
          onClick={() => handleDataLayerEvent(link.display_name, link.page_link.cached_url, 'Side Nav Menu')}
        >
          <AccordionItemState>
            {state => state && <Link state={state} textColor={textColor} link={link} />}
          </AccordionItemState>
        </AccordionItemButton>
      </AccordionItemHeading>

      <AccordionItemPanel className="px-6 bg-sherpa-blue-50 bg-SP7">
        <CustomLink
          url={link.page_link.cached_url}
          className={`block py-3 !text-sherpa-blue-900 text-Body font-semibold text-sm`}
          key={link._uid}
          onClick={() => handleDataLayerEvent(link.display_name, link.page_link.cached_url, 'Side Nav Menu')}
        >
          <span>{link.display_name}</span>
        </CustomLink>

        {link.dropdown_list?.length &&
          link.dropdown_list.map(sublink => (
            <CustomLink
              url={sublink.page_link.cached_url}
              className={`block py-3 !text-sherpa-blue-900 text-Body font-semibold text-sm`}
              key={sublink._uid}
              onClick={() => handleDataLayerEvent(sublink.display_name, sublink.page_link.cached_url, 'Side Nav Item Menu Dropdown', link.display_name)}
            >
              <span>{sublink.display_name}</span>
            </CustomLink>
          ))}
      </AccordionItemPanel>
    </AccordionItem>
  ) : (
    <div className="group">
      <div className="px-3">
        <CustomLink
          url={link.page_link.cached_url}
          className={`block py-3 !text-sherpa-blue-900 ${
            textColor === 'primary' ? 'text-Primary-700 font-bold' : 'text-Body font-semibold'
          } text-sm`}
          key={link._uid}
          onClick={() => handleDataLayerEvent(link.display_name, link.page_link.cached_url, 'Side Nav Menu')}
        >
          <span>{link.display_name}</span>
        </CustomLink>
      </div>
    </div>
  );
};

export default AccorionItemComponent;
